import { Button } from '@erelego/design-system';
/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  IAdvancedRulesClient,
  IAdvancedRulesServer,
  IFieldLevelRuleServer,
  IFieldsMap,
  IForm,
  IFormLevelRuleServer,
  IPageLevelRuleServer,
  ISubForm,
  ISubFormsMap,
  ISubmissionLevelRuleServer,
} from "@common/redux/formBuilder/interface";
import {
  transformDateTimeInputConfigServerToClient,
  transformDateTimeInputFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormDateTimePickerField/utils";
import {
  transformCheckBoxInputFieldConfigClientToServer,
  transformCheckBoxInputConfigServerToClient,
} from "@presentation/FormBuilder/components/FormCheckboxField/utils";
import {
  FieldProps,
  FormFieldTypes,
  IFieldValuesConfiguration,
} from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import {
  IFormServer,
  IFieldServer,
  ISubFormServer,
  IFieldValuesConfigurationServer,
  IFormLevelRuleClient,
  IFieldLevelRuleConditionMap,
  IFieldLevelRuleClient,
  IInfographicsDashboardDataServer,
  IInfographicsDashboardDataClient,
  IFieldLevelRuleConditionClient,
  IFormLevelRuleConditionMap,
  IAddNewFormActionPayload,
  ICustomPermission,
  componentScopeEnum,
  formEnum,
  ISubmissionLevelRuleClient,
  ISubmissionLevelRuleConditionClient,
  ISubmissionLevelRuleConditionMap,
  ICustomPermissionServer,
  pageEnum,
} from "./interface";
import {
  transformDropdownFieldConfigClientToServer,
  transformDropdownFieldConfigServerToClient,
} from "@presentation/FormBuilder/components/FormDropdownField/utils";
import {
  transformMultiChoiceConfigServerToClient,
  transformMultipleChoiceFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormMultipleChoicesField/utils";
import {
  transformCurrencyConfigServerToClient,
  transformCurrencyFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormCurrencyField/utils";
import {
  transformFileUploadConfigServerToClient,
  transformFileUploadFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormFileUploadField/utils";
import {
  transformLinearScalingConfigServerToClient,
  transformLinearScalingFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormLinearScaleField/utils";
import {
  transformTextAreaFieldConfigClientToServer,
  transformTextAreatConfigServerToClient,
} from "@presentation/FormBuilder/components/FormTextAreaField/utils";
import {
  transformTextInputConfigServerToClient,
  transformTextInputFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormTextInputField/utils";
import {
  uniqueIdType,
  generateUniqueId,
  ConditionType,
} from "@presentation/FormBuilder/utils";
import {
  transformDateInputConfigServerToClient,
  transformDateInputFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormDateField/utils";
import {
  transformTimePickerFieldConfigServerToClient,
  transformTimePickerFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormTimePickerField/Utils";
import {
  transformRatingConfigServerToClient,
  transformRatingFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormRatingField/utils";
import {
  IPageLevelRuleClient,
  IFieldLevelRuleConditionServer,
} from "@presentation/FormBuilder/components/ConfiguredRule/interface";
import {
  transformCalculativeInputConfigServerToClient,
  transformCalculativeInputFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormCalculativeInputField/utils";
import {
  transformPaymentInputConfigServerToClient,
  transformPaymentInputFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormPaymentInputField/utils/fieldUtils";
import {
  transformSectionConfigClientToServer,
  transformSectionConfigServerToClient,
} from "@presentation/FormBuilder/components/FormSectionOverviewComponent/utils";
import {
  transformNumberInputConfigServerToClient,
  transformNumberInputFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormNumberInputField/utils";
import {
  transformLookUpConfigServerToClient,
  transformLookUpFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormLookupField/utils";
import {
  transformGeolocationConfigServerToClient,
  transformGeolocationFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormGeolocationField/utils";
import {
  transformTableFieldConfigClientToServer,
  transformTabletConfigServerToClient,
} from "@presentation/FormBuilder/components/FormTableField/utils";
import {
  transformPincodeConfigServerToClient,
  transformPincodeFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormPincodeField/utils";
import {
  transformSequenceFieldConfigClientToServer,
  transformSequenceFieldConfigServerToClient,
} from "@presentation/FormBuilder/components/FormSequenceField/utils";
import {
  transformButtonConfigClientToServer,
  transformButtonConfigServerToClient,
} from "@presentation/FormBuilder/components/FormButtonField/utils";

import {
  transformDoublePanelFieldConfigServerToClient,
  transformDoublePanelFieldConfigClientToServer,
} from "@presentation/FormBuilder/components/FormDoublePanelField/utils";

import { transformFormFieldConfigClientToServer, transformFormLinkConfigServerToClient } from "@presentation/FormBuilder/components/FormLinkField/utils";

import { transformFormYearDropdownFieldConfigClientToServer } from "@presentation/FormBuilder/components/FormYearsDropdown/utils";
import { transformFormYearDropdownFieldConfigServerToClient } from "@presentation/FormBuilder/components/FormYearsDropdown/utils";
import {
  transformBannerConfigClientToServer,
  transformBannerConfigServerToClient,
} from "@presentation/FormBuilder/components/FormBannerField/utils";

import {
  transformTimeSlotFieldConfigClientToServer,
  transformTimeSlotFieldConfigServerToClient
} from "@presentation/FormBuilder/components/FormTimeSlot/util";

import {
  transformSignatureFieldConfigClientToServer,
  transformSignatureFieldConfigServerToClient
} from "@presentation/FormBuilder/components/FormSignatureComponent/utils"
import { transformCaptchaFieldConfigClientToServer, transformCaptchaConfigServerToClient } from '@presentation/FormBuilder/components/FormCaptchaField/utils';
import { transformLinkedDropdownFieldConfigClientToServer, transformLinkedDropdownConfigServerToClient } from '@presentation/FormBuilder/components/FormLinkedDropdownField/utils';
import { transformDescriptionFieldConfigClientToServer,transformDescriptionFieldConfigServerToClient } from '@presentation/FormBuilder/components/DescriptionField/utils';

export const transformFormDataServerToClient = (
  formDataServer: IFormServer
): IForm => {
  if (!formDataServer) return;

  const fieldsMapClient: IFieldsMap = {};
  const subFormsMapClient: ISubFormsMap = {};
  const subFormsClient: string[] = [];
  const formId = formDataServer?.id;
  let overviewFormClient: string[];

  const handleFieldMap = (fieldsData: IFieldServer[], parentFormId = "") => {
    const fieldIds: string[] = [];
    if (fieldsData) {
      fieldsData.forEach((fieldData: IFieldServer, index: number) => {
        if (!fieldData) return;

        const {
          localId,
          fieldType,
          title,
          element,
          type,
          name,
          description,
          descriptionType,
          grid,
          isVisible,
          isDisabled,
          isRequired,
          isFocus,
          canDelete,
          canCopy,
          canAdd,
          createdDate,
          updatedDate,
          fieldConfig,
          fields,
          rules,
          id,
          referenceId,
          prefix,
          postfix,
          eyeIcon,
          completeEncrypt,
          sequenceType,
          hideFromVisiblity,
          generateSequenceByWorkflow,
          numericSequenceCount,
          defaultSequenceValue,
          dateRangeEnabled,
          isWeekendDisabled,
          specificDateSelectionEnabled,
          specificDateRangeEnabled,
          jsonApiEnabled,
          preDisableDateCount,
          postDisableDateCount,
          specificDates,
          specificDateRange,
          dateJsonApiUrl,
          slotDuration,
          slotSetting,
          dateReferralFieldId,
          isPartOfTimeSlot,
          isCurrentDateSelected,
          dateInitialValueType,
          isCurrentTimeSelected,
          timeInitialValueType,
          isCurrentDateTimeSelected,
          dateTimeInitialValueType,
          isPastDateDisabled,
          fromFieldId,
          toFieldId,
          isRegularTimeFormat,
          fromTimeFieldId,
          toTimeFieldId,
          isTimeOfDayRequired,
          timeOfDayFieldId,
          isMonthDisplayRequired,
          monthDisplayFieldId,
          timeOfDayConfig,
        } = fieldData;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const { isDuplicateAllowed, isPII } = fieldConfig;

        const fieldsClient =
          fieldData?.fields?.length > 0
            ? handleFieldMap(fieldData?.fields, localId)
            : [];
        const settings = {
          visibility: {
            isVisible: isVisible,
            isDisabled: isDisabled,
          },
        };

        const fieldDataClient: FieldProps = {
          localId,
          fieldType,
          isSection: fieldType == FormFieldTypes?.SECTION,
          title,
          description,
          isRequired,
          isDuplicateAllowed,
          descriptionType,
          isPII,
          position: index,
          fields: fieldsClient,
          rules,
          grid,
          settings,
          parentFormId,
          formId,
          type,
          name: name ?? title,
          element,
          id,
          isVisible,
          isDisabled,
          isFocus,
          createdDate,
          updatedDate,
          referenceId,
          prefix,
          postfix,
          eyeIcon,
          completeEncrypt,
          sequenceType,
          numericSequenceCount,
          defaultSequenceValue,
          dateRangeEnabled,
          isWeekendDisabled,
          specificDateSelectionEnabled,
          specificDateRangeEnabled,
          jsonApiEnabled,
          preDisableDateCount,
          postDisableDateCount,
          specificDates,
          specificDateRange,
          dateJsonApiUrl,
          slotDuration,
          slotSetting,
          dateReferralFieldId,
        } as FieldProps;

        let fieldConfigClient: IFieldValuesConfiguration = {};

        if (fieldConfig) {
          switch (fieldType) {
            case FormFieldTypes.DROPDOWN:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformDropdownFieldConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.MULTIPLE_CHOICES:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformMultiChoiceConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.LINEAR_SCALING:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformLinearScalingConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.FILE_UPLOAD:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformFileUploadConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.CURRENCY:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformCurrencyConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.PAYMENT:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformPaymentInputConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.GEOLOCATION:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformGeolocationConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.TEXT_INPUT:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformTextInputConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.FORM_LINK:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformFormLinkConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.YEAR_SELECTOR:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformFormYearDropdownFieldConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.LOOKUP:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformLookUpConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.NUMBER_INPUT:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformNumberInputConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.PIN_CODE:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformPincodeConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.TEXT_AREA:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformTextAreatConfigServerToClient(fieldConfig);   
              break;
            case FormFieldTypes.DESCRIPTION:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformDescriptionFieldConfigServerToClient(fieldConfig);   
              break;

            case FormFieldTypes.DATE_INPUT:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformDateInputConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.DATE_TIME_PICKER:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformDateTimeInputConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.TIME_PICKER:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformTimePickerFieldConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.RATING:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformRatingConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.CALCULATIVE:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformCalculativeInputConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.CHECK_BOX:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformCheckBoxInputConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.SECTION:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformSectionConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.DATA_GRID:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformTabletConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.SEQUENCE:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformSequenceFieldConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.TIME_SLOT:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformTimeSlotFieldConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.BUTTON:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformButtonConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.BANNER:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformBannerConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.SIGNATURE_BOX:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformSignatureFieldConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.DOUBLE_PANEL:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformDoublePanelFieldConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.CAPTCHA:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformCaptchaConfigServerToClient(fieldConfig);
              break;
            case FormFieldTypes.LINKED_DROPDOWN:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              fieldConfigClient = transformLinkedDropdownConfigServerToClient(fieldConfig);
              break;

            default:
              break;
          }
        }
        // if (fields?.length > 0) {
        //   fieldConfigClient = transformSectionConfigServerToClient(fieldConfig);
        // }
        fieldDataClient.fieldValue = fieldConfigClient;
        fieldIds.push(localId);
        fieldsMapClient[localId] = fieldDataClient;
      });
    }

    return fieldIds;
  };

  if (formDataServer?.subForms) {
    formDataServer?.subForms?.forEach((subFormData: ISubFormServer) => {
      const { localId, title, description, number } = subFormData;
      const subFormfieldsClient: string[] =
        subFormData?.fields && handleFieldMap(subFormData?.fields, localId);

      const subFormDataClient: ISubForm = {
        localId,
        title,
        description,
        position: number,
        fields: subFormfieldsClient,
      } as ISubForm;

      subFormsClient.push(localId);
      subFormsMapClient[localId] = subFormDataClient;
    });
  }

  if (formDataServer?.fields) {
    overviewFormClient = handleFieldMap(
      formDataServer?.fields,
      formDataServer?.localId
    );
  }
  const {
    title,
    description,
    isMultipleForm,
    subForms,
    id,
    createdBy,
    updatedBy,
    name,
    fields,
    localId,
    settings,
    overviewForm,
    updatedDate,
    isDisabled,
    createdDate,
    isMultipleSubAllowed,
    sendEmailAlerts,
    isAnonymousSubAllowed,
    relatedFormIds,
    isOverviewAllowed,
    isDraftViewAllowed,
    isApprovalRequired,
    isReSubmissionAllowed,
    isDeadlineEnabled,
    isDynamicDeadlineEnabled,
    dynamicDeadlineFieldId,
    approvalFieldId,
    deadlineEndDate,
    deadlineStartDate,
    formLogo,
    enableFieldNumbering,
    folderPath,
    themeId,
    applicationId,
    environment,
    visibility,
    isCompositeKeyEnabled,
    deleteActionRequired,
    isReferenceByFieldsMap,
    rowActionsRequired,
    isSearchRequired,
    compositeKeyFields,
    isQrCodeRequired,
    qrCodeRefField,
    qrCodeRefPageIds,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    slotDuration,
    slotSetting,
    dateReferralFieldId,
    isPartOfTimeSlot,
    isCurrentDateSelected,
    isTemplate,
    dateInitialValueType,
    isCurrentTimeSelected,
    timeInitialValueType,
    isCurrentDateTimeSelected,
    dateTimeInitialValueType,
    customSuccessMessage,
    customUpdateSuccessMessage,
    fieldCount,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId,
    isTimeOfDayRequired,
    timeOfDayFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
    timeOfDayConfig,
    isValidationRequiredbeforeSubmission,
    isScriptOnFormSubmission,
    scriptOnSubmission,
    validationModal,
    otpModal,
    otpMethod,
    otpMethodValue
  } = formDataServer;

  const submissionDeadline = {
    startDate: deadlineStartDate,
    endDate: deadlineEndDate,
    isDeadlineEnabled,
    isDynamicDeadlineEnabled,
    dynamicDeadlineFieldId:dynamicDeadlineFieldId,
  };

  const formDataClient: IForm = {
    id,
    localId: id,
    title,
    name,
    description,
    isMultipleForm, //subFormsClient?.length > 0,
    activeFormStep: 0,
    overviewForm: overviewFormClient,
    fieldsMap: fieldsMapClient,
    subForms: subFormsClient,
    subFormsMap: subFormsMapClient,
    updatedDate,
    isDisabled,
    createdDate,
    isMultipleSubAllowed,
    sendEmailAlerts,
    isAnonymousSubAllowed,
    relatedFormIds: relatedFormIds || [],
    isOverviewAllowed,
    isDraftViewAllowed,
    isApprovalRequired,
    approvalFieldId,
    isReSubmissionAllowed,
    submissionDeadline,
    formLogo,
    enableFieldNumbering,
    folderPath: folderPath || "/",
    themeId: themeId ?? "",
    applicationId: applicationId || "",
    environment: environment || "",
    visibility,
    isCompositeKeyEnabled,
    deleteActionRequired,
    isReferenceByFieldsMap,
    rowActionsRequired,
    isSearchRequired,
    compositeKeyFields,
    isQrCodeRequired,
    qrCodeRefField,
    qrCodeRefPageIds,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    slotDuration,
    slotSetting,
    dateReferralFieldId,
    isPartOfTimeSlot,
    isTemplate,
    isCurrentDateSelected,
    dateInitialValueType,
    isCurrentTimeSelected,
    timeInitialValueType,
    isCurrentDateTimeSelected,
    dateTimeInitialValueType,
    customSuccessMessage,
    customUpdateSuccessMessage,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId,
    fieldCount: fieldCount || 0,
    isTimeOfDayRequired,
    timeOfDayFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
    timeOfDayConfig,
    isValidationRequiredbeforeSubmission : isValidationRequiredbeforeSubmission || false,
    isScriptOnFormSubmission : isScriptOnFormSubmission || false,
    scriptOnSubmission: scriptOnSubmission || "",
    validationModal: validationModal || false,
    otpModal : otpModal || false,
    otpMethod : otpMethod || "",
    otpMethodValue
  } as IForm;

  return formDataClient;
};

export const transformFormDataClientToServer = (
  formDataClient: IForm
): IFormServer => {
  if (!formDataClient) return;
  const subFormsServer: ISubFormServer[] = [];

  const getFieldData = (fieldId: string) => {
    if (!fieldId) return;
    const formFieldsMap = formDataClient?.fieldsMap;
    const fieldDataClient: FieldProps = formFieldsMap[fieldId];
  
    const {
      localId,
      fieldType,
      isSection,
      title,
      description,
      isRequired,
      isDuplicateAllowed,
      descriptionType,
      isPII,
      position,
      isDisabled,
      fields,
      rules,
      grid,
      fieldValue,
      settings,
      type,
      name,
      element,
      id,
      referenceId,
      prefix,
      postfix,
      eyeIcon,
      completeEncrypt,
      sequenceType,
      numericSequenceCount,
      dateRangeEnabled,
      isWeekendDisabled,
      specificDateSelectionEnabled,
      specificDateRangeEnabled,
      jsonApiEnabled,
      preDisableDateCount,
      postDisableDateCount,
      specificDates,
      specificDateRange,
      dateJsonApiUrl,
      slotDuration,
      slotSetting,
      dateReferralFieldId,
      isPartOfTimeSlot,
      isCurrentDateSelected,
      dateInitialValueType,
      isCurrentTimeSelected,
      timeInitialValueType,
      isCurrentDateTimeSelected,
      dateTimeInitialValueType,
      isPastDateDisabled,
      fromFieldId,
      toFieldId,
      isRegularTimeFormat,
      fromTimeFieldId,
      toTimeFieldId,
      isTimeOfDayRequired,
      timeOfDayFieldId, 
      isMonthDisplayRequired,
      monthDisplayFieldId,
      timeOfDayConfig,
    } = fieldDataClient;
    let fieldDataServer = {
      localId,
      fieldType,
      title,
      description,
      grid,
      isDisabled: settings?.visibility?.isDisabled,
      isVisible: settings?.visibility?.isVisible,
      isRequired,
      fields,
      type,
      name: name ?? title,
      element,
      id,
      isFocus: null,
      rules,
      canDelete: true,
      canCopy: true,
      canAdd: true,
      referenceId,
      descriptionType,
      fieldConfig: {
        isDuplicateAllowed,
        isPII: isPII || false,
        encryptDetails: null,
        isQrCodeAllowed: false,
        eyeIcon: false,
        completeEncrypt: false,
        dateRangeEnabled,
        isWeekendDisabled,
        specificDateSelectionEnabled,
        specificDateRangeEnabled,
        jsonApiEnabled,
        preDisableDateCount,
        postDisableDateCount,
        specificDates,
        specificDateRange,
        dateJsonApiUrl,
        slotDuration,
        slotSetting,
        dateReferralFieldId,
        isPartOfTimeSlot,
        isCurrentDateSelected,
        dateInitialValueType,
        isCurrentTimeSelected,
        timeInitialValueType,
        isCurrentDateTimeSelected,
        dateTimeInitialValueType,
        isPastDateDisabled,
        fromFieldId,
        toFieldId,
        isRegularTimeFormat,
        fromTimeFieldId,
        toTimeFieldId,
        isTimeOfDayRequired,
        timeOfDayFieldId,
        isMonthDisplayRequired,
        monthDisplayFieldId,
        timeOfDayConfig,
      },
    } as IFieldServer;

    const serverFields: IFieldServer[] =
      fields?.length >= 0
        ? fields?.map((fieldId: string) => getFieldData(fieldId))
        : undefined;

    fieldDataServer.fields = serverFields;
    if (fieldType == FormFieldTypes.SECTION && serverFields.length == 0) {
      return;
    }
    let fieldConfigServer: IFieldValuesConfigurationServer =
      fieldDataServer?.fieldConfig;

    switch (fieldType) {
      case FormFieldTypes.DROPDOWN:
        // @ts-ignore
        fieldConfigServer =
          transformDropdownFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.MULTIPLE_CHOICES:
        // @ts-ignore
        fieldConfigServer =
          transformMultipleChoiceFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.LINEAR_SCALING:
        // @ts-ignore
        fieldConfigServer =
          transformLinearScalingFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.FILE_UPLOAD:
        // @ts-ignore
        fieldConfigServer =
          transformFileUploadFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.CURRENCY:
        // @ts-ignore
        fieldConfigServer =
          transformCurrencyFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.TEXT_INPUT:
        // @ts-ignore
        fieldConfigServer =
          transformTextInputFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.FORM_LINK:
        // @ts-ignore
        fieldConfigServer =
          transformFormFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.YEAR_SELECTOR:
        // @ts-ignore
        fieldConfigServer =
          transformFormYearDropdownFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.NUMBER_INPUT:
        // @ts-ignore
        fieldConfigServer =
          transformNumberInputFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.PIN_CODE:
        // @ts-ignore
        fieldConfigServer =
          transformPincodeFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.TEXT_AREA:
        // @ts-ignore
        fieldConfigServer =
          transformTextAreaFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.DESCRIPTION:
        // @ts-ignore
        fieldConfigServer =
          transformDescriptionFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.DATE_INPUT:
        // @ts-ignore
        fieldConfigServer =
          transformDateInputFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.DATE_TIME_PICKER:
        // @ts-ignore
        fieldConfigServer =
          transformDateTimeInputFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.TIME_PICKER:
        // @ts-ignore
        fieldConfigServer =
          transformTimePickerFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.RATING:
        // @ts-ignore
        fieldConfigServer =
          transformRatingFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.CALCULATIVE:
        // @ts-ignore
        fieldConfigServer =
          transformCalculativeInputFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.PAYMENT:
        fieldConfigServer =
          transformPaymentInputFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.GEOLOCATION:
        fieldConfigServer =
          transformGeolocationFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.CHECK_BOX:
        // @ts-ignore
        fieldConfigServer =
          transformCheckBoxInputFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.LOOKUP:
        // @ts-ignore
        fieldConfigServer =
          transformLookUpFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.SECTION:
        // @ts-ignore
        fieldConfigServer = transformSectionConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.DATA_GRID:
        // @ts-ignore
        fieldConfigServer = transformTableFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.SEQUENCE:
        // @ts-ignore
        fieldConfigServer =
          transformSequenceFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.TIME_SLOT:
        // @ts-ignore
        fieldConfigServer =
          transformTimeSlotFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.BUTTON:
        // @ts-ignore
        fieldConfigServer =
          transformButtonConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.BANNER:
        // @ts-ignore
        fieldConfigServer =
          transformBannerConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.SIGNATURE_BOX:
        // @ts-ignore
        fieldConfigServer =
          transformSignatureFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.DOUBLE_PANEL:
        // @ts-ignore
        fieldConfigServer =
          transformDoublePanelFieldConfigClientToServer(fieldValue);
        break;

      case FormFieldTypes.CAPTCHA:
        // @ts-ignore
        fieldConfigServer =
          transformCaptchaFieldConfigClientToServer(fieldValue);
        break;
      case FormFieldTypes.LINKED_DROPDOWN:
        // @ts-ignore
        fieldConfigServer =
          transformLinkedDropdownFieldConfigClientToServer(fieldValue);
        break;
    }
    // if (fieldType == FormFieldTypes.SECTION) {
    //   fieldConfigServer = transformSectionConfigClientToServer(fieldValue);
    // }

    fieldDataServer = {
      ...fieldDataServer,
      fieldConfig: {
        ...fieldDataServer?.fieldConfig,
        ...fieldConfigServer,
      },
    };
    return fieldDataServer;
  };

  if (formDataClient?.subForms) {
    formDataClient?.subForms?.forEach((subFormId: string, index) => {
      const subFormClient: ISubForm = formDataClient?.subFormsMap[subFormId];

      const { localId, title, description, fields, position } = subFormClient;

      const serverFields = fields?.map((fieldId) => getFieldData(fieldId));

      const subFormServer: ISubFormServer = {
        localId,
        title,
        description,
        fields: serverFields,
        number: position,
      } as ISubFormServer;

      subFormsServer.push(subFormServer);
    });
  }

  const overviewFormServer: IFieldServer[] = formDataClient?.overviewForm?.map(
    (fieldId: string) => getFieldData(fieldId)
  );
  const filteredOverviewFormServer = overviewFormServer.filter((field) => {
    return field !== undefined;
  });
  const {
    localId,
    title,
    description,
    isMultipleForm,
    isDisabled,
    updatedDate,
    createdDate,
    isMultipleSubAllowed,
    sendEmailAlerts,
    isAnonymousSubAllowed,
    relatedFormIds,
    isOverviewAllowed,
    isDraftViewAllowed,
    isApprovalRequired,
    approvalFieldId,
    isReSubmissionAllowed,
    submissionDeadline,
    formLogo,
    enableFieldNumbering,
    folderPath,
    themeId,
    applicationId,
    environment,
    visibility,
    isCompositeKeyEnabled,
    deleteActionRequired,
    isReferenceByFieldsMap,
    rowActionsRequired,
    isSearchRequired,
    compositeKeyFields,
    isQrCodeRequired,
    qrCodeRefField,
    qrCodeRefPageIds,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    slotDuration,
    slotSetting,
    dateReferralFieldId,
    isPartOfTimeSlot,
    customSuccessMessage,
    customUpdateSuccessMessage,
    isCurrentDateSelected,
    dateInitialValueType,
    isCurrentTimeSelected,
    timeInitialValueType,
    isCurrentDateTimeSelected,
    dateTimeInitialValueType,
    fieldCount,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId,
    isTimeOfDayRequired,
    timeOfDayFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
    timeOfDayConfig,
    isValidationRequiredbeforeSubmission,
    isScriptOnFormSubmission,
    scriptOnSubmission,
    validationModal,
    otpModal,
    otpMethod,
    otpMethodValue
  } = formDataClient;

  const { isDeadlineEnabled, endDate ,dynamicDeadlineFieldId ,isDynamicDeadlineEnabled } = submissionDeadline;
  const deadlineEndDate = isDeadlineEnabled ? endDate : 0;
  const deadlineStartDate = isDeadlineEnabled ? Date.now() : 0; // current date and time in seconds
  const updatedIsDeadlineEnabled = deadlineEndDate !== 0; // to disable deadline if date is not selected
  const approvalFieldsId = isApprovalRequired ? approvalFieldId : "";
  const updatedDynamicDeadlineEnabled = isDynamicDeadlineEnabled;
  const formDataServer: IFormServer = {
    title,
    description,
    isMultipleForm,
    formLogo,
    id: localId,
    fields: filteredOverviewFormServer,
    localId,
    isDisabled: isDisabled || false,
    updatedDate,
    createdDate,
    subForms: subFormsServer,
    isMultipleSubAllowed,
    sendEmailAlerts,
    isAnonymousSubAllowed,
    relatedFormIds: relatedFormIds || [],
    isOverviewAllowed,
    isDraftViewAllowed,
    isApprovalRequired,
    approvalFieldId: approvalFieldsId,
    isReSubmissionAllowed,
    isDeadlineEnabled: updatedIsDeadlineEnabled,
    isDynamicDeadlineEnabled:updatedDynamicDeadlineEnabled,
    dynamicDeadlineFieldId:dynamicDeadlineFieldId,
    deadlineEndDate,
    deadlineStartDate,
    enableFieldNumbering,
    folderPath: folderPath || "/",
    themeId: themeId ?? "",
    applicationId: applicationId || "",
    environment: environment || "",
    visibility,
    isCompositeKeyEnabled,
    deleteActionRequired,
    isReferenceByFieldsMap,
    rowActionsRequired,
    isSearchRequired,
    compositeKeyFields,
    isQrCodeRequired,
    qrCodeRefField,
    qrCodeRefPageIds,
    dateRangeEnabled,
    isWeekendDisabled,
    specificDateSelectionEnabled,
    specificDateRangeEnabled,
    jsonApiEnabled,
    preDisableDateCount,
    postDisableDateCount,
    specificDates,
    specificDateRange,
    dateJsonApiUrl,
    slotDuration,
    slotSetting,
    dateReferralFieldId,
    isPartOfTimeSlot,
    customSuccessMessage,
    customUpdateSuccessMessage,
    isCurrentDateSelected,
    dateInitialValueType,
    isCurrentTimeSelected,
    timeInitialValueType,
    isCurrentDateTimeSelected,
    dateTimeInitialValueType,
    isPastDateDisabled,
    fromFieldId,
    toFieldId,
    isRegularTimeFormat,
    fromTimeFieldId,
    toTimeFieldId,
    fieldCount: fieldCount || 0,
    isTimeOfDayRequired,
    timeOfDayFieldId,
    isMonthDisplayRequired,
    monthDisplayFieldId,
    timeOfDayConfig,
    isValidationRequiredbeforeSubmission: isValidationRequiredbeforeSubmission || false,
    isScriptOnFormSubmission: isScriptOnFormSubmission || false,
    scriptOnSubmission: scriptOnSubmission || false,
    validationModal: validationModal || false,
    otpModal : otpModal || false,
    otpMethod : otpMethod || "",
    otpMethodValue
  } as IFormServer;
  return formDataServer;
};

export const EMPTY_FORM_DATA: IAddNewFormActionPayload = {
  fields: [],
  subForms: [],
  title: "Change Title",
  folderPath: "/",
};

export const duplicateForm = (
  formDataServer: IFormServer,
  duplicateFormId: string
): IFormServer => {
  if (!formDataServer) return;
  const { title, fields, subForms } = formDataServer;
  const formTitle = title ? title : "Untitled Form";
  const duplicateFieldMap = (fieldsData: IFieldServer[]) => {
    let allFieldsDuplicate: IFieldServer[] = [];
    if (fieldsData) {
      fieldsData.forEach((fieldData: IFieldServer) => {
        if (!fieldData) return;
        const duplicateFields =
          fieldData?.fields?.length > 0
            ? duplicateFieldMap(fieldData?.fields)
            : [];

        const fieldDataDuplicate: IFieldServer = {
          ...fieldData,
          localId: generateUniqueId(uniqueIdType.FIELD, duplicateFormId),
        } as IFieldServer;
        allFieldsDuplicate = [...allFieldsDuplicate, fieldDataDuplicate];
      });
    }

    return allFieldsDuplicate;
  };

  const subFormDuplicate: ISubFormServer[] = [];
  if (subForms) {
    subForms?.forEach((subFormData: ISubFormServer) => {
      const subFormFieldDuplicate: ISubFormServer = {
        ...subFormData,
        localId: generateUniqueId(uniqueIdType.SUBFORM, duplicateFormId),
        fields: subFormData?.fields && duplicateFieldMap(subFormData?.fields),
      };
      subFormDuplicate.push(subFormFieldDuplicate);
    });
  }

  let fieldsDuplicate: IFieldServer[];
  if (fields) {
    fieldsDuplicate = duplicateFieldMap(fields);
  }

  const formDataDuplicate: IFormServer = {
    ...formDataServer,
    title: "copy of " + formTitle,
    subForms: subFormDuplicate,
    id: duplicateFormId,
    fields: fieldsDuplicate,
    createdDate: null,
    updatedDate: null,
    isDisabled: false, // must remove during merge
  } as IFormServer;

  return formDataDuplicate;
};

// const emptyDefaultFieldValueServer:IFieldServer={
//   id: null,
//   fieldType: null,
//   title: null,
//   description: null,
//   isVisible: null,
//   isDisabled: null,
//   isRequired: false,
//   isFocus: null,
//   grid: {
//     width: 0
//   },
//   canDelete: null,
//   canCopy: null,
//   canAdd: null,
//   element: null,
//   type: "TEXT_INPUT",
//   name: null,
//   sequenceNumber: null,
//   groupId: null,
//   localId: null,
//   initialValue: null,
//   rules: null,
//   placeHolder: null,
//   isDuplicateAllowed: true,
//   isPII: true,
//   encryptDetails: {
//     options:null,
//     selected: null,
//     multiSelected: null
//   },
//   isQrCodeAllowed: true
// }

// not to remove start transform without modification

// export const transformFormDataServerToClient = (formDataServer: IFormServer): IForm => {

//   if (!formDataServer) return;

//   const fieldsMapClient: IFieldsMap = {};
//   const subFormsMapClient:ISubFormsMap = {};
//   const subFormsClient: string[] = [];
//   let overviewFormClient: string[];

//   const handleFieldMap = (fieldsData: IFieldServer[]) => {

//     const fieldIds: string[] = [];
//     if(fieldsData) {
//       fieldsData?.forEach((fieldData: IFieldServer, index: number) => {
//         if(!fieldData) return;

//         const {
//           localId,
//           fieldType,
//           isFocus,
//           grid,
//           rules,
//           title,
//           description,
//           isDisabled,
//           isRequired,
//           placeHolder,
//           // is not supported by client side
//           sequenceNumber,
//           groupId,
//           initialValue,
//           id,
//           canDelete,
//           canCopy,
//           canAdd,
//           element,
//           type,
//           name,
//           isVisible,
//           isDuplicateAllowed,
//           isPII,
//           encryptDetails,
//           isQrCodeAllowed,
//           fields
//         } = fieldData;

//         const fieldsClient = (fieldData?.fields?.length > 0) ? handleFieldMap(fieldData.fields) : [];

//         const fieldDataClient: FieldProps = {
//           localId,
//           fieldType,

//           isSection: (fields?.length > 0),
//           title,
//           description,
//           isRequired,
//           position: index,
//           fieldValue: {
//             title,
//             description,
//             isRequired,
//             placeholder:placeHolder,
//           },
//           settings: {
//             visibility: {
//                 isVisible,
//                 isDisabled,
//               }
//           },
//           fields: fieldsClient,
//           rules,
//           grid,

//         } as FieldProps;

//         fieldIds.push(fieldData.localId);
//         fieldsMapClient[fieldData.localId] = fieldDataClient;
//       });
//     }

//     return fieldIds;
//   };

//     if(formDataServer?.subForms) {
//       formDataServer.subForms?.forEach((subFormData: ISubFormServer) => {

//         const subFormLocalId = subFormData.localId;
//         const subFormfieldsClient: string[] = subFormData?.fields && handleFieldMap(subFormData.fields);

//         const subFormDataClient: ISubForm = {
//           localId: subFormLocalId,
//           title: subFormData.title,
//           description: subFormData.description,
//           position: subFormData.number,
//           fields: subFormfieldsClient,
//         } as ISubForm;

//         subFormsClient.push(subFormLocalId);//to prevent crash during opening the forms
//         subFormsMapClient[subFormLocalId] = subFormDataClient;//to prevent crash during opening the forms
//       });
//     }

//     if(formDataServer.fields) {
//       overviewFormClient = handleFieldMap(formDataServer.fields);
//     }

//     const {
//       title,
//       description,
//       isMultipleForm,
//       subForms,
//       id,
//       createdBy,
//       updatedBy,
//       name,
//       fields,
//       localId,
//       settings,
//       overviewForm,
//     } = formDataServer;

//     const formDataClient: IForm = {
//       id,
//       localId:id,
//       title,
//       description,
//       isMultipleForm, //subFormsClient?.length > 0,
//       activeFormStep: 0,
//       overviewForm: overviewFormClient,
//       fieldsMap: fieldsMapClient,
//       subForms: subFormsClient,
//       subFormsMap: subFormsMapClient
//     } as IForm;

//   return formDataClient;
// };

// export const transformFormDataClientToServer = (formDataClient: IForm):IFormServer => {
//   if (!formDataClient) return;

//   const subFormsServer: ISubFormServer[] = [];

//   const getFieldData = (fieldId: string) => {

//     const formFieldsMap = formDataClient?.fieldsMap;

//     const fieldDataClient: FieldProps  = formFieldsMap[fieldId];

//     const {
//       localId,
//       fieldType,

//       isSection,
//       title,
//       description,
//       isRequired,
//       position,

//       isDisabled,

//       fields,
//       rules,
//       grid,
//       fieldValue,
//       settings

//     } = fieldDataClient;

//     const fieldDataServer = {
//       localId,
//       fieldType,
//       grid,
//       rules,
//       title: fieldValue?.title,
//       description: fieldValue?.description,
//       placeHolder:fieldValue?.placeholder,
//       isDisabled:settings?.visibility?.isDisabled,
//       isRequired:fieldValue?.isRequired,
//       isVisible:settings?.visibility?.isVisible,
//       id: localId,
//     } as IFieldServer;

//     const serverFields: IFieldServer[] = (fields?.length >= 0)  ? fields?.map((fieldId: string) => getFieldData(fieldId)) : undefined;

//     fieldDataServer.fields = serverFields;

//     return fieldDataServer;
//   }

//  if(formDataClient.subForms){
//   formDataClient.subForms.forEach((subFormId : string, index) => {

//     const subFormClient: ISubForm = formDataClient.subFormsMap[subFormId];

//     const {
//       localId,
//       title,
//       description,
//       fields,
//       position

//     } = subFormClient;

//     const serverFields = fields?.length > 0 && fields?.map((fieldId) => getFieldData(fieldId));

//     const subFormServer: ISubFormServer = {
//       localId,
//       title,
//       description,
//       fields: serverFields,
//       number: position,
//     } as ISubFormServer;

//     subFormsServer.push(subFormServer);
//     });
//   }

//   const overviewFormServer: IFieldServer[] = formDataClient.overviewForm?.map((fieldId: string) => getFieldData(fieldId));

//   const {
//     localId,
//     title,
//     description,
//     isMultipleForm,
//   } = formDataClient;

//   const formDataServer: IFormServer = {
//    title,
//    description,
//    isMultipleForm,
//    id:localId,
//    fields:overviewFormServer,
//    localId,
//    subForms:subFormsServer,
//   } as IFormServer;
//   return formDataServer;
// };

// not to remove end

export const transformRuleDataClientToServer = (
  ruleDataClient: IAdvancedRulesClient,
  activeFormId: string
): IAdvancedRulesServer => {
  const formId = ruleDataClient?.formId || activeFormId;
  const fieldRules: IFieldLevelRuleClient[] = ruleDataClient?.fieldRules || [];
  const pageRules: IPageLevelRuleClient[] = ruleDataClient?.pageRules || [];
  const formRules: IFormLevelRuleClient[] = ruleDataClient?.formRules || [];
  const submissionRules: ISubmissionLevelRuleClient[] =
    ruleDataClient?.submissionRules || [];
  const fieldConditionMap: IFieldLevelRuleConditionMap =
    ruleDataClient?.fieldConditionMap;
  const pageConditionMap: IFieldLevelRuleConditionMap =
    ruleDataClient?.pageConditionMap;
  const formConditionMap: IFormLevelRuleConditionMap =
    ruleDataClient?.formConditionMap;
  const submissionConditionMap: ISubmissionLevelRuleConditionMap =
    ruleDataClient?.submissionConditionMap;
  const getConditionsData = (
    conditionIds: string[],
    conditionMap: IFieldLevelRuleConditionMap
  ): IFieldLevelRuleConditionServer[] => {
    const fieldConditionServer: IFieldLevelRuleConditionServer[] = [];
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      let fieldConditionData = { ...(conditionMap[conditionId] ?? {}) };
      if (fieldConditionData.fieldValueType == ConditionType.form_field) {
        if (
          typeof fieldConditionData.value == "object" &&
          fieldConditionData.value &&
          "value" in fieldConditionData.value
        ) {
          const valueObject = fieldConditionData.value as {
            value: any;
          }; // Type assertion

          fieldConditionData = {
            ...fieldConditionData,
            value: valueObject.value,
          };
        }
      } else if (
        fieldConditionData.fieldValueType == ConditionType.user_field ||
        fieldConditionData.fieldValueType == ConditionType.system_fields
      ) {
        if (
          typeof fieldConditionData.value === "object" &&
          fieldConditionData.value !== null &&
          "value" in fieldConditionData.value
        ) {
          const valueObject = fieldConditionData.value as {
            value: any;
          }; // Type assertion
          fieldConditionData = {
            ...fieldConditionData,
            value: valueObject.value,
          };
        }
      }
      const {
        logicalOperator,
        fieldConditionIds,
        fieldConditionId,
        operator,
        value,
        fieldType,
        fieldLocalId,
        subFormLocalId,
        action,
        conditionName,
        fieldValueType = "",
        conditionType = "",
      } = fieldConditionData;
      const fieldConditionsServer: IFieldLevelRuleConditionServer[] =
        getConditionsData(fieldConditionIds, conditionMap);
      const fieldConditionDataServer: IFieldLevelRuleConditionServer = {
        logicalOperator:
          fieldConditionsServer?.length > 0 ? logicalOperator : undefined,
        operator,
        value,
        fieldType,
        fieldLocalId,
        subFormLocalId,
        action,
        conditions: fieldConditionsServer,
        fieldValueType,
        conditionType,
        // conditionName,
      };
      fieldConditionServer.push(fieldConditionDataServer);
    }
    return fieldConditionServer;
  };

  const getFieldRuleDataServerFormat = (
    fieldRuleClient: IFieldLevelRuleClient
  ): IFieldLevelRuleServer => {
    const { ruleName, logicalOperator, fieldConditionIds } = fieldRuleClient;
    const fieldConditionsServer: IFieldLevelRuleConditionServer[] =
      getConditionsData(fieldConditionIds, fieldConditionMap);
    const fieldRuleServer: IFieldLevelRuleServer = {
      ruleName,
      logicalOperator,
      conditions: fieldConditionsServer,
      action: fieldRuleClient?.action,
    };

    return fieldRuleServer;
  };

  const getPageRuleDataServerFormat = (
    pageRulesClient: IPageLevelRuleClient
  ): IPageLevelRuleServer => {
    const { ruleName, logicalOperator, pageConditionIds } = pageRulesClient;
    const fieldConditionsServer: IFieldLevelRuleConditionClient[] =
      getConditionsData(pageConditionIds, pageConditionMap);
    const pageRuleServer: IPageLevelRuleServer = {
      ruleName,
      logicalOperator,
      conditions: fieldConditionsServer,
      action: pageRulesClient?.action,
    };

    return pageRuleServer;
  };
  const getFormRuleDataServerFormat = (
    formRulesClient: IFormLevelRuleClient
  ): IFormLevelRuleServer => {
    const { ruleName, logicalOperator, formConditionIds } = formRulesClient;
    const fieldConditionsServer: IFieldLevelRuleConditionClient[] =
      getConditionsData(formConditionIds, formConditionMap);
    const pageRuleServer: IFormLevelRuleServer = {
      ruleName,
      logicalOperator,
      conditions: fieldConditionsServer,
      formAction: formRulesClient?.formAction || [],
    };

    return pageRuleServer;
  };
  const getSubmissionRuleDataServerFormat = (
    submissionRulesClient: ISubmissionLevelRuleClient
  ): ISubmissionLevelRuleServer => {
    const { ruleName, logicalOperator, submissionConditionIds } =
      submissionRulesClient;
    const submissionConditionsServer: ISubmissionLevelRuleConditionClient[] =
      getConditionsData(submissionConditionIds, submissionConditionMap);
    const pageRuleServer: ISubmissionLevelRuleServer = {
      ruleName,
      logicalOperator,
      conditions: submissionConditionsServer,
      submissionAction: submissionRulesClient?.submissionAction || {},
    };

    return pageRuleServer;
  };

  const fieldRulesServer: IFieldLevelRuleServer[] = [];
  fieldRules?.forEach((fieldRuleClient: IFieldLevelRuleClient) => {
    const fieldRuleServer: IFieldLevelRuleServer =
      getFieldRuleDataServerFormat(fieldRuleClient);
    if (
      fieldRuleClient?.action?.hide?.length > 0 ||
      fieldRuleClient?.action?.show?.length > 0
    ) {
      fieldRulesServer.push(fieldRuleServer);
    }
  });

  const pageRulesServer: IPageLevelRuleServer[] = [];
  pageRules?.forEach((pageRulesClient: IPageLevelRuleClient) => {
    const pageRuleServer: IPageLevelRuleServer =
      getPageRuleDataServerFormat(pageRulesClient);
    if (
      pageRulesClient?.action?.skip?.length > 0 ||
      pageRulesClient?.action?.show?.length > 0 ||
      pageRulesClient?.action?.hide?.length > 0 ||
      pageRulesClient?.action?.elseSkip?.length > 0
    ) {
      pageRulesServer.push(pageRuleServer);
    }
  });
  const formRulesServer: IFormLevelRuleServer[] = [];
  formRules?.forEach((formRulesClient: IFormLevelRuleClient) => {
    const formRuleServer: IFormLevelRuleServer =
      getFormRuleDataServerFormat(formRulesClient);
    if (formRulesClient?.formAction?.length > 0) {
      formRulesServer.push(formRuleServer);
    }
  });
  const submissionRulesServer: ISubmissionLevelRuleServer[] = [];
  submissionRules?.forEach(
    (submissionRulesClient: ISubmissionLevelRuleClient) => {
      const submissionRuleServer: ISubmissionLevelRuleServer =
        getSubmissionRuleDataServerFormat(submissionRulesClient);
      if (submissionRulesClient?.submissionAction?.value) {
        submissionRulesServer.push(submissionRuleServer);
      }
    }
  );

  const ruleDataServer: IAdvancedRulesServer = {
    formId,
    pageRules: pageRulesServer,
    formRules: formRulesServer, //pending
    fieldRules: fieldRulesServer,
    submissionRules: submissionRulesServer,
  };
  return ruleDataServer;
};

export const transformInfographicsDashboardDataServerToClient = (
  infographicsData: IInfographicsDashboardDataServer
): IInfographicsDashboardDataClient => {
  const {
    data = [],
    formId = "",
    noOfColumns,
    noOfRows,
    dashboardName,
    id,
  } = infographicsData;

  const updatedInfographicsWidgetMap = {};
  const widgetIds = [];

  for (const index in data) {
    const widgetData = data[index];
    const localId = widgetData?.localId;
    widgetIds.push(localId);
    updatedInfographicsWidgetMap[localId] = widgetData;
  }

  const infographicsDataClient: IInfographicsDashboardDataClient = {
    widgetIds,
    infographicsWidgetMap: updatedInfographicsWidgetMap ?? {},
    formId,
    noOfColumns,
    noOfRows,
    dashboardName,
    id,
  };

  return infographicsDataClient;
};

export const transformInfographicsDashboardDataClientToServer = (
  infographicsDataClient: IInfographicsDashboardDataClient
): IInfographicsDashboardDataServer => {
  const {
    widgetIds,
    infographicsWidgetMap = {},
    formId,
    noOfColumns,
    noOfRows,
    dashboardName = "Dashboard Name",
    id,
  } = infographicsDataClient;

  const updatedWidgetDatas = [];

  for (const widgetId of widgetIds) {
    const widgetData = infographicsWidgetMap[widgetId];
    updatedWidgetDatas.push(widgetData);
  }

  const infographicsDataServer: IInfographicsDashboardDataServer = {
    data: updatedWidgetDatas,
    formId,
    noOfColumns,
    noOfRows,
    dashboardName,
    id,
  };

  return infographicsDataServer;
};
export const convertFieldToFieldsMap = (fields) => {
  const map = {};
  const allFields = getAllFields(fields);
  for (const field of allFields) {
    map[field["localId"]] = field;
  }
  return map;
};

export const getAllFields = (fields) => {
  let allFields = [...fields];
  for (const field of allFields) {
    if (field.fieldType === "SECTION")
      allFields = [...allFields, ...getAllFields(field.fields)];
  }
  return allFields;
};

export const customPermissionInitialState: ICustomPermission = {
  applicationId: "",
  clientId: "",
  roleId: "",
  forms: {},
  formPage: {},
  components: {},
  pages: {},
};

export const convertCustomPermissionServerToClient = (
  permissionsServer: ICustomPermissionServer[]
): ICustomPermission => {
  const result: ICustomPermission = {
    forms: {},
    components: {},
    formPage: {},
    pages: {},
  };

  permissionsServer?.forEach((json: any) => {
    // Convert forms
    for (const formKey in json.forms) {
      if (!result.forms[formKey]) {
        result.forms[formKey] = [];
      }
      result.forms[formKey] = prioritizeFormPermission(
        result.forms[formKey],
        json?.forms[formKey]
      );
    }

    // Convert components
    for (const pageKey in json.components) {
      if (!result.components[pageKey]) {
        result.components[pageKey] = {};
      }
      for (const componentKey in json.components[pageKey]) {
        if (!result.components[pageKey][componentKey]) {
          result.components[pageKey][componentKey] = [];
        }
        result.components[pageKey][componentKey] = prioritizePermission(
          result.components[pageKey][componentKey],
          json.components[pageKey][componentKey]
        );
      }
    }

    // Convert form pages
    for (const pageKey in json.formPage) {
      if (!result.formPage[pageKey]) {
        result.formPage[pageKey] = {};
      }
      for (const componentKey in json.formPage[pageKey]) {
        if (!result.formPage[pageKey][componentKey]) {
          result.formPage[pageKey][componentKey] = [];
        }
        result.formPage[pageKey][componentKey] = prioritizePagePermission(
          result.formPage[pageKey][componentKey],
          json.formPage[pageKey][componentKey]
        );
      }
    }

    // Convert pages
    for (const pageKey in json.pages) {
      if (!result.pages[pageKey]) {
        result.pages[pageKey] = {};
      }
      for (const componentKey in json.pages[pageKey]) {
        if (!result.pages[pageKey][componentKey]) {
          result.pages[pageKey][componentKey] = [];
        }
        result.pages[pageKey][componentKey] = prioritizePermission(
          result.pages[pageKey][componentKey],
          json.pages[pageKey][componentKey]
        );
      }
    }
  });

  return result;
};
const prioritizePagePermission = (
  existing: pageEnum[],
  incoming: pageEnum[]
): pageEnum[] => {
  const priority: pageEnum[] = [pageEnum.SHOW, pageEnum.HIDE];
  const merged: pageEnum[] = [...existing, ...incoming];
  const unique = Array.from(new Set(merged));

  return unique.sort(
    (a: pageEnum, b) => priority.indexOf(b) - priority.indexOf(a)
  );
};

const prioritizePermission = (
  existing: componentScopeEnum[],
  incoming: componentScopeEnum[]
): componentScopeEnum[] => {
  const priority: componentScopeEnum[] = [
    componentScopeEnum.WRITE,
    componentScopeEnum.READ,
    componentScopeEnum.HIDE,
  ];
  const merged: componentScopeEnum[] = [...existing, ...incoming];
  const unique = Array.from(new Set(merged));

  return unique.sort(
    (a: componentScopeEnum, b) => priority.indexOf(b) - priority.indexOf(a)
  );
};

const prioritizeFormPermission = (
  existing: formEnum[],
  incoming: formEnum[]
): formEnum[] => {
  const priority: formEnum[] = [
    formEnum.VIEW_ALL,
    formEnum.VIEW_HIERARCHY,
    formEnum.VIEW_OWN,
  ];
  const merged: formEnum[] = [...existing, ...incoming];
  const unique = Array.from(new Set(merged));

  return unique.sort(
    (a: formEnum, b) => priority.indexOf(b) - priority.indexOf(a)
  );
};

export const encodeParams = (
  obj: Record<string, string | number | boolean>
): string => {
  return Object.entries(obj)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`
    )
    .join("&");
};
export const getPagesWithHideAction = (data): string[] => {
  const updatedData = data ?? {};
  const pagesWithHide = [];

  for (const key in updatedData) {
    if (updatedData[key]?.includes("HIDE")) {
      pagesWithHide.push(key);
    }
  }

  return pagesWithHide;
};
